export enum FileType {
	// Image file types
	IMAGE_PNG = 'image/png',
	IMAGE_JPEG = 'image/jpeg',
	IMAGE_GIF = 'image/gif',
	IMAGE_WEBP = 'image/webp',
	IMAGE_SVG = 'image/svg+xml',

	// Audio file types
	AUDIO_MP3 = 'audio/mpeg',
	AUDIO_WAV = 'audio/wav',
	AUDIO_OGG = 'audio/ogg',
	AUDIO_AAC = 'audio/aac',
	AUDIO_FLAC = 'audio/flac',
	AUDIO_WEBM = 'audio/webm',
	AUDIO_M4A = 'audio/m4a',
	AUDIO_XM4A = 'audio/x-m4a',

	// Video file types
	VIDEO_MP4 = 'video/mp4',
	VIDEO_WEBM = 'video/webm',
	VIDEO_OGG = 'video/ogg',
	VIDEO_AVI = 'video/x-msvideo',
	VIDEO_MOV = 'video/quicktime',
	VIDEO_MKV = 'video/x-matroska',

	// Document file types
	PDF = 'application/pdf',
	DOC = 'application/msword',
	DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	XLS = 'application/vnd.ms-excel',
	XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	PPT = 'application/vnd.ms-powerpoint',
	PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',

	// Misc file types
	TXT = 'text/plain',
	JSON = 'application/json',
	CSV = 'text/csv',
	ZIP = 'application/zip',
	RAR = 'application/x-rar-compressed',
}
export class FileTypeService {
	static getImageTypes(): string[] {
		return [FileType.IMAGE_PNG, FileType.IMAGE_JPEG, FileType.IMAGE_GIF, FileType.IMAGE_WEBP, FileType.IMAGE_SVG];
	}

	static getAudioTypes(): string[] {
		return [
			FileType.AUDIO_MP3,
			FileType.AUDIO_WAV,
			FileType.AUDIO_OGG,
			FileType.AUDIO_AAC,
			FileType.AUDIO_FLAC,
			FileType.AUDIO_WEBM,
			FileType.AUDIO_M4A,
			FileType.AUDIO_XM4A,
		];
	}

	static getVideoTypes(): string[] {
		return [FileType.VIDEO_MP4, FileType.VIDEO_WEBM, FileType.VIDEO_OGG, FileType.VIDEO_AVI, FileType.VIDEO_MOV, FileType.VIDEO_MKV];
	}

	static getDocTypes(): string[] {
		return [FileType.PDF, FileType.DOC, FileType.DOCX, FileType.XLS, FileType.XLSX, FileType.PPT, FileType.PPTX];
	}

	static getMediaTypes(): string[] {
		return [...FileTypeService.getImageTypes(), ...FileTypeService.getAudioTypes(), ...FileTypeService.getVideoTypes()];
	}

	static getMediaAndDocTypes(): string[] {
		return [...FileTypeService.getMediaTypes(), ...FileTypeService.getDocTypes()];
	}

	static getAllTypes(): string[] {
		return [
			...FileTypeService.getImageTypes(),
			...FileTypeService.getAudioTypes(),
			...FileTypeService.getVideoTypes(),
			...FileTypeService.getDocTypes(),
			FileType.TXT,
			FileType.JSON,
			FileType.CSV,
			FileType.ZIP,
			FileType.RAR,
		];
	}

	static getFileIcon(contentType: FileType): string {
		if (!contentType) return 'bi-file';

		if (contentType.startsWith('image/')) return 'bi-file-image';
		if (contentType.startsWith('audio/')) return 'bi-file-music';
		if (contentType.startsWith('video/')) return 'bi-file-play';
		if (contentType === FileType.PDF) return 'bi-filetype-pdf';
		if (contentType === FileType.TXT) return 'bi-filetype-txt';
		if (contentType === FileType.JSON) return 'bi-filetype-json';
		if (contentType === FileType.CSV) return 'bi-filetype-csv';
		if (contentType === FileType.ZIP || contentType === FileType.RAR) return 'bi-file-zip';

		const typeIconMap: { [key: string]: string } = {
			[FileType.DOC]: 'bi-filetype-doc',
			[FileType.DOCX]: 'bi-filetype-docx',
			[FileType.XLS]: 'bi-filetype-xls',
			[FileType.XLSX]: 'bi-filetype-xlsx',
			[FileType.PPT]: 'bi-filetype-ppt',
			[FileType.PPTX]: 'bi-filetype-pptx',
		};

		return typeIconMap[contentType] || 'bi-file';
	}
}
